import CardTable from "components/CardTable/CardTable";
import React, { useEffect } from "react";
import RegularButton from "components/CustomButtons/Button";
import WidgetsIcon from "@mui/icons-material/Widgets";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";

import {
  getAllByShipmentNumber,
  getCarriers,
  getAllShipperTruck,
  getNationalNotes,
} from "redux/actions/inventories/inventShipmentsActions";

import { setSnackbar } from "redux/actions/search/searchActions";
import { columnsShipmentOpen } from "./columnsShipment";
import { TextField } from "@mui/material";
import { useForm } from "hooks/useForm.js";
import { useSearch } from "hooks/useSearch";

const tableKey = "inventoryShipmentTable";
const loadings = ["loadingInventory"];

export const ShipmentTable = ({
  title = "",
  columns = [],
}) => {
  const dispatch = useDispatch();
  const { buildTableConfig, restoreTable, buildCompLoadings } = useSearch();
  const { inventory, station } = useSelector(({ inventories }) => inventories);
  const { isLoadingComp, configTables } = useSelector( ({ search }) => search );
  const shipmentsInventory = inventory?.details.shipmentsInventory || [];
  const {
    inputValues,
    handleInputOnChange,
    cleanForm,
  } = useForm({ searchShipmentNumber: "" });
  const { searchShipmentNumber } = inputValues;

  const handleSearchShipmentNumber = (e) => {
    e.preventDefault();
    if (searchShipmentNumber.length === 0) {
      dispatch(
        setSnackbar("Por favor introduce el número de embarque", "warning")
      );
      return;
    }
    cleanForm();
    restoreTable(tableKey);
    dispatch(getAllByShipmentNumber(searchShipmentNumber));
  };

  useEffect(() => {
    buildCompLoadings(loadings);
    !configTables[tableKey] && buildTableConfig(tableKey);
    dispatch(getCarriers())
    dispatch(getAllShipperTruck())
    shipmentsInventory?.length > 0 && dispatch(getNationalNotes(station.id))
  }, []);

  return (
    <CardTable
      hasHeader
      title={title}
      icon={<WidgetsIcon />}
      blockBtn
      columns={inventory?.status !== "CLOSED" ? columnsShipmentOpen : columns}
      data={shipmentsInventory}
      isLoading={isLoadingComp?.loadingInventory}
      tableKey={tableKey}
      hasControl
      controls={
        <>
          {inventory?.status !== "CLOSED" && (
            <form onSubmit={handleSearchShipmentNumber}>
              <TextField
                name="searchShipmentNumber"
                value={searchShipmentNumber}
                onChange={handleInputOnChange}
                variant="outlined"
                size="small"
                placeholder="Número de embarque"
                InputProps={{
                  endAdornment: (
                    <>
                      <RegularButton
                        justIcon
                        round
                        color="transparent"
                        size="sm"
                        onClick={handleSearchShipmentNumber}
                        type="submit"
                      >
                        <SearchIcon />
                      </RegularButton>
                      <CloseIcon
                        onClick={cleanForm}
                        style={{ cursor: "pointer", margin: 0 }}
                      />
                    </>
                  ),
                }}
              />
            </form>
          )}
        </>
      }
    />
  );
};
